import classNames from "classnames";
import useIframe from "utils/iframe/useIframe";
import externals from "utils/externals";
import styles from "../../ServiceIframe.module.scss";
import useCurrentService from "utils/useCurrentService";
import { appComponents as i18nNamespace } from "../../../../i18n/namespace";
import { useTranslation } from "react-i18next";
import { getIframeAllow } from "./getIframeAllow";

/**
 * V1 is deprecated, dont update it, any new integrations must be on V2
 */
export const RenderV1 = ({ version, iframeKey, isThirdParty, trackKey, setWizardOpen, isWizardOpen }) => {
    const { t } = useTranslation(i18nNamespace);
    const service = useCurrentService();
    const { iframeRef, src } = useIframe({ iframeUrl: externals.serviceIframes[iframeKey], isThirdParty, trackKey, setWizardOpen })

    return <iframe title={t("service")} allow={getIframeAllow(service?.uiIntegration)} src={src} ref={iframeRef} className={classNames((service.isShowingSelectedServiceNav ? styles.appBase : styles.appBaseWithoutLeftNav), { [styles['sub-tab']]: !service.isShowingSelectedServiceNav && version === "childIframe/v1" && !isWizardOpen })}/>
};